class ExpandableContentSection extends HTMLElement {
    constructor() {
        super();
        const expandButton = this.querySelectorAll('.expandable-content__expand-button');
        const expandingSection = this.querySelector('.expandable-content__expandable');

        expandButton.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                expandingSection.classList.toggle('expandable-content__expandable--is-open');
            });
        });
    }
}

customElements.define('expandable-content-section', ExpandableContentSection);
